import { createContext, useContext } from 'react';

export const SceneTimeContext = createContext({
  t: 0, playing: false, duration: 20, stage: 0, groupT: 0, tMV: null, groupTMV: null,
  mode: 'present', audioOn: false,
});

export const useSceneTime = () => useContext(SceneTimeContext);

// progress 0..1 of t between a and b
export const seg = (t, a, b) => Math.max(0, Math.min(1, (t - a) / (b - a)));
export const easeOut = (p) => 1 - Math.pow(1 - p, 3);
export const easeInOut = (p) => (p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2);
export const EASE = [0.22, 1, 0.36, 1];
